import { render } from "./DatabasesTable.vue?vue&type=template&id=05f3038f"
import script from "./DatabasesTable.vue?vue&type=script&lang=js"
export * from "./DatabasesTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__